import { t } from "i18next";
import * as yup from "yup";

export const registerValidationSchema = () => {
  return yup.object().shape({
    fullName: yup.string().required(t("form.error.fullName.required")!),
    email: yup
      .string()
      .min(3, " ")
      .max(50, " ")
      .email(t("form.error.email.emailForm")!)
      .required(t("form.error.email.required")!),
    userName: yup
      .string()
      .matches(/^\S+$/, t("form.error.userName.space")!)
      .matches(/^[^0-9].*$/, " "!)
      .matches(/^[A-Za-z0-9_-]*[-_.][A-Za-z0-9_-]*$/, " "!)
      .min(3, " "!)
      .max(20, " "!)
      .required(t("form.error.userName.required")!),
    password: yup
      .string()
      .min(8, " ")
      .max(20, " ")
      .required(t("form.error.password.required")!),
    confirmPassword: yup
      .string()
      .oneOf(
        [yup.ref("password"), ""],
        t("form.error.confirmPassword.matching")!
      )
      .required(t("form.error.confirmPassword.required")!),
  });
};
